export default {
  en: {
    'shared.add': 'Add',
    'shared.delete': 'Delete',
    'shared.cancel': 'Cancel',
    'shared.close': 'Close',
    'shared.quantity': 'Quantity',
    'shared.name': 'Name',
    'shared.date': 'Date',
    'shared.code': 'Code',
    'shared.description': 'Description',
    'shared.price': 'Price',
    'shared.subtotal': 'Total Parcial',
    'shared.company': 'Company',
    'shared.addedBy': 'Added by',
    'shared.status': 'Status',
    'shared.resolvedBy': 'Resolved by',
    'shared.voucherNumber': 'Voucher number',

    'auth.signin': 'Login',
    'auth.password': 'Password',
    'auth.forgot_password': 'Forgot password?',
    'auth.dont_have_an_account': "Don't have an account? Sign Up",
    'auth.already_have_an_account': 'Already have an account? Sign in',
    'auth.reset': 'Reset',
    'auth.sign_up': 'Sign up',
    'auth.add_admin': 'Add new user',
    calendar: 'Calendar',
    'calendar.from': 'From',
    'calendar.to': 'To',
    'calendar.apply': 'Apply',
    'calendar.monday': 'Monday',
    'calendar.tuesday': 'Tuesday',
    'calendar.wednesday': 'Wednesday',
    'calendar.thursday': 'Thursday',
    'calendar.friday': 'Friday',
    'calendar.saturday': 'Saturday',
    'calendar.sunday': 'Sunday',
    'calendar.show_picker': 'Show Availability Time Picker',
    'calendar.hide_picker': 'Hide Availability Time Picker',
    'calendar.edit': 'Edit',
    'calendar.cancel': 'Cancel',
    'calendar.delete': 'Delete',
    'calendar.add': 'Add',
    'calendar.save': 'Save',
    'calendar.one_day': 'One day',
    'calendar.in_range': 'In range',
    'doctor.title': 'Title',
    'doctor.title.none': 'None',
    'doctor.title.lic': 'Lic.',
    'doctor.title.ing': 'Ing.',
    'doctor.title.ph_d': 'Ph.D.',
    'doctor.title.dr': 'Dr.',
    'doctor.title.mtro': 'Mtro.',
    'doctor.title.mtr': 'Mtr.',
    'doctor.title.sr_sra': 'Sr. / Sra.',
    'doctor.role': 'Job position',
    'doctor.collegiate_number': 'Collegiate Number',
    'doctor.skills': 'Skills',
    inventory: 'Inventory',
    'inventory.add_new_item': 'Add new item',
    'inventory.sku_description': 'Code',
    'inventory.inventory_name': 'Inventory Name',
    'inventory.name': 'Name',
    'inventory.date': 'Date',
    'inventory.price': 'Price',
    'inventory.cost': 'Cost',
    'inventory.quantity': 'Quantity',
    'inventory.total_cost': 'Total cost',
    'inventory.description': 'Description',
    'inventory.provide_info': 'To add your inventory item, please provide information inputs below',
    'inventory.add': 'Add',
    'inventory.add_service': 'Add service',
    'inventory.add_exam': 'Add exam',
    'inventory.add_inventory': 'Add inventory',
    'inventory.cancel': 'Cancel',
    'inventory.status': 'Status',
    'inventory.type': 'Type',
    'inventory.link': 'Link',
    'inventory.doctor_comment': 'Physician comment',
    'inventory.field_to_save_link': 'Field to save link',
    'inventory.expert_judge': 'Expert judgement',
    'inventory.find_by_sku': 'Find by Code',
    'inventory.find_by_patient': 'Find by patient',
    'inventory.details': 'Inventory details',
    'calendar.close': 'Close',
    'navbar.profile': 'Profile',
    'navbar.medicals': 'Staff',
    'navbar.patient_record': 'Patient Records',
    'navbar.calendar': 'Calendar',
    'navbar.services': 'Services',
    'navbar.inventory': 'Inventory',
    'navbar.requests': 'Requests',
    'navbar.admin_accounts': 'Patient Bills',
    'navbar.assigned_services': 'Patient Bills',
    'patient.bills': 'Patient Bills',
    'patient.totalAmount': 'Total amount',
    'patient.totalAmountPaid': 'Total amount paid',
    'patient.totalAmountToPay': 'Total amount to pay',
    'patient.accountNumber': 'Account Number',
    'patient.amount': 'Amount',
    'patient.registered': 'Registered by',
    'patient.addNewPayment': 'Add new payment',
    'patient.checkout': 'Check out',

    position: 'Position',
    'position.none': 'None',
    'position.doctor': 'Physician',
    'position.pharmacist': 'Pharmacist',
    'position.nurse': 'Nurse',
    'position.patient': 'Patient',
    'position.technician_radiology': 'Technician (Radiology)',
    'position.technician_labs': 'Technician (Laboratory)',
    'position.technition': 'Technician',
    'position.admin': 'Webmaster',
    'position.staff': 'Manager',
    'position.find_specialist': 'Find staff member',
    'position.find_patient': 'Find patient',
    'position.find_request': 'Find request',
    'position.find_service': 'Find service',
    'position.find_inventory': 'Find inventory',
    'position.find_catalog': 'Find catalogue',
    profile: 'Profile',
    'profile.edit_profile': 'Edit profile',
    'profile.view_profile': 'View profile',
    'record.name': 'Name',
    'record.author': 'Author',
    'record.date': 'Date',
    'record.add_new': 'Add new medical record',
    'request.add_new_item': 'Add new exam',
    request: 'Request',
    services: 'Services',
    'services.exams': 'Exams',
    'services.add_new_item': 'Add New Service',
    'services.sku_description': 'Code',
    'services.sku': 'Code',
    'services.name': 'Name',
    'services.price': 'Price',
    'services.title': 'Title',
    'services.type': 'Type',
    'services.description': 'Description',
    'services.medida': 'Presentation',
    'services.status': 'Status',
    'services.provide_info': 'To add your service, please provide information inputs below',
    'services.add': 'Add',
    'services.cancel': 'Cancel',
    'services.service.name': 'Service name',
    'services.doctor_comment': 'Physician comment',
    'services.deadline_date': 'Date',
    'services.company': 'Company',
    exams: 'Exams',
    'exam.sku_description': 'Code',
    'exam.sku': 'Code',
    'exam.name': 'Name',
    'exam.price': 'Price',
    'exam.description': 'Description',
    'exam.status': 'Status',
    'exam.add_new_exam': 'Add new exam',
    medicaments: 'Medicaments',
    'medicament.sku_description': 'Code',
    'medicament.sku': 'Code',
    'medicament.name': 'Name',
    'medicament.price': 'Price',
    'medicament.quantity': 'Quantity',
    'medicament.total_cost': 'Total cost',
    'medicament.status': 'Status',
    'medicament.add_new_item': 'Add new medicament',
    supplies: 'Supplies',
    'supply.sku_description': 'Code',
    'supply.sku': 'Code',
    'supply.name': 'Name',
    'supply.price': 'Price',
    'supply.quantity': 'Quantity',
    'supply.total_cost': 'Total cost',
    'supply.status': 'Status',
    'supply.add_new_item': 'Add new supply',
    'user.email_adress': 'Email Address',
    'user.phone': 'Phone',
    'user.first_name': 'First Name',
    'user.name': 'Name',
    'user.last_name': 'Last Name',
    'user.role': 'Role',
    'user.search': 'Search',
    'user.payment_type': 'Method of Payment',
    'user.view': 'View',
    'user.profile': 'Profile',
    'user.accounts': 'Bills',
    'user.medical_records': 'Medical Records',
    'user.medical_record': 'Medical Record',
    'user.assign_doctor': 'Assign Physician',
    'user.remove': 'Remove',
    'user.add_comment': 'Add comment',
    'user.observation': 'Comments',
    'user.leave_comment': 'Leave a comment',
    'users.confirm_removing': 'Confirm removing',
    'user.not_found': 'User not found',
    'VAT.percent': 'VAT',
    'vat.change_value': 'Change VAT',
    'home.log_in': 'Log in',
    'auth.back_to_login': 'Back to sign in',
    'auth.restore_link_sent': 'Link was send to your email allowing to setup your password',
    'service.status.paid': 'Paid',
    'service.status.unpaid': 'Unpaid',

    'calendar.Lunes': 'Monday',
    'calendar.Martes': 'Tuesday',
    'calendar.Miercoles': 'Wednesday',
    'calendar.Jueves': 'Thursday',
    'calendar.Viernes': 'Friday',
    'calendar.Sabado': 'Saturday',
    'calendar.Domingo': 'Sunday',
    'calendar.new_event': 'Add new event',
    'calendar.provide_event_info': 'To add your event to calendar, please provide information in input below.',
    'calendar.provide_event_label': 'Event information',

    'medical_record.man': 'Man',
    'medical_record.woman': 'Woman',
    'medical_records.medical_records': 'Medical records',
    'medical_records.dialog_title': 'Add new medical record',
    'medical_records.record_name': 'Record name',
    'medicalRecord.author': 'Author',
    'medicalRecord.viewMedRecord': 'View medical record',
    'medicalRecord.addNewRecord': 'Add new record',

    'patient.download_info': 'Download patient info',
    'patient_dialog.assign_doctor': 'Assign physician',
    'patient_dialog.doctor': 'Physician',
    'patient_dialog.assign': 'Assign',
    'patient.self_pay': 'Self pay',
    'patient.social_security': 'Social security',

    'exam.mark_as_done': 'Done',
    'exam.close_request': 'Close request',
    'exam.document_link': 'Document link',
    'exam.expert_judgement': 'Expert judgement',

    'service_item_type.service': 'Service',
    'service_item_type.surgery': 'Surgery',
    'service_item_type.laboratory_exam': 'Laboratory Exam',
    'service_item_type.radiological_exam': 'Radiological Exam',
    'service_item_type.procedure': 'Procedure',
    'service_item_type.hospitality': 'Hospitality',

    'accounts_table.exam_dialog_info': 'Exam info',
    'accounts_table.exam_dialog_close': 'Close',
    'accounts_table.medicament_dialog_info': 'Medicament info',
    'accounts_table.medicament_dialog_close': 'Close',
    'accounts_table.supply_dialog_info': 'Supply info',
    'accounts_table.supply_dialog_close': 'Close',

    'assign_inventory.title': 'Select inventory',
    'assign_inventory.info': 'Select inventory',
    'assign_inventory.quantity': 'Quantity',
    'assign_inventory.paymentType': 'Method of Payment',
    'assign_inventory.cash': 'Cash',
    'assign_inventory.insurance': 'Insurance',
    'assign_inventory.credit_card': 'Credit Card',
    'assign_request.title': 'Select exam',
    'assign_request.exam': 'Exam',
    'assign_request.quantity': 'Method of Payment',
    'assign_request.paymentType': 'Method of Payment',
    'assign_request.deadline': 'Date',
    'assign_request.comment': 'Comment',
    'assign_service.title': 'Select service',
    'assign_service.service': 'Service',
    'assign_service.paymentType': 'Method of Payment',

    'navbar.logout': 'Log out',
    'patient.case_ID': 'Patient ID',

    'medical_record.restore_fields': 'Restore fields',
    'medical_record.field': 'Field',

    'medical_record.laboratory_exams': 'Laboratory Exams',
    'medical_record.radiological_exams': 'Radiological Exams',
    'medical_record.clinical_treatment': 'Clinical Treatment',
    'medical_record.surgical_treatment': 'Surgical Treatment',
    'medical_record.procedures_in_treatment': 'Procedures in Treatment',
    'medical_record.vital_signs': 'Vital Signs',
    'medical_record.personal_medical_history': 'Personal Medical History',
    'medical_record.family_medical_history': 'Family Medical History',
    'medical_record.symptoms': 'Symptoms',
    'medical_record.signs': 'Signs',
    'medical_record.gender': 'Gender',
    'medical_record.age': 'Age',
    'medical_record.address': 'Address',
    'medical_record.recent_trips': 'Recent Trips',
    'medical_record.weight': 'Weight',
    'medical_record.height': 'Height',
    'medical_record.body_temperature': 'Body Temperature',
    'medical_record.heart_rate': 'Heart Rate',
    'medical_record.bpm': 'Breaths per Minute',
    'medical_record.blood_pressure': 'Blood Pressure',
    'medical_record.oxygen_saturation': 'Oxygen Saturation',
    'medical_record.sodium_blood_test': 'Sodium Blood Test',
    'medical_record.potassium_blood_test': 'Potassium Blood Test',
    'medical_record.chloride_blood_test': 'Chloride Blood Test',
    'medical_record.bicarbonate_blood_test': 'Bicarbonate Blood Test',
    'medical_record.blood_urea_nitrogen_test': 'Blood Urea Nitrogen Test',
    'medical_record.glucose_blood_test': 'Glucose Blood Test',
    'medical_record.platelet_blood_count': 'Platelet Blood Count',
    'medical_record.creatinine_blood_test': 'Creatinine Blood Test',
    'medical_record.white_blood_cell_count': 'White Blood Cell Count',
    'medical_record.hematocrit_blood_test': 'Hematocrit Blood Test',
    'medical_record.liver_function_tests': 'Liver Function Tests',
    'medical_record.kidney_function_tests': 'Kidney Function Tests',
    'medical_record.special_request_tests': 'Special Request Tests',
    'medical_record.ultrasound_results': 'Ultrasound Results',
    'medical_record.x_rays_results': 'X-Rays Results',
    'medical_record.ct_scan_results': 'CT-Scan Results',
    'medical_record.mri_results': 'MRI Results',
    'medical_record.pet/ct_results': 'PET/CT Results',
    'medical_record.diagnostic': 'Diagnostic',
    'medical_record.days_in_treatment': 'Days in Treatment',
    'medical_record.medication_for_treatment': 'Medication for Treatment',

    'inventory_type.medicine': 'Medicine',
    'inventory_type.supplies': 'Supplies',
    'inventory_type.supply': 'Supply',
    'inventory_type.service': 'Service',
    'inventory_type.services': 'Services',
    'inventory_type.exam': 'Exam',
    'inventory_type.inventory': 'Inventory',

    'patient_modal.add_new_patient': 'Add new patient',
    'doctor_modal.add_new_medical': 'Add new medical specialist',
    'doctor_modal.add_new_admin': 'Add new admin',
    catalogue: 'catalogue',
    'catalogue.add_new_item': 'Add new catalogue',
    'catalogue.medicamentos': 'Medicaments',
    'catalog.inventory': 'Catalogue',
    'catalogue.sku': 'Code',
    'catalogue.name': 'Catalog name',
    'catalogue.price': 'Price',
    'catalogue.type': 'Type',
    'catalogue.category': 'Category',
    'catalogue.cancel': 'Cancel',
    'catalogue.add': 'Add',
    'catalogue.provide_info': 'To add your catalogue item, please provide information inputs below',
    'catalogue.compania': 'Company',
    'catalogue.codigo': 'Code',
    'catalogue.descripcion': 'Description',
    'catalogue.disponible': 'Available',
    'catalogue.bodega': 'Store',
    'catalogue.nombreBodega': 'Company',
    'catalogue.precio': 'Price',
    'catalogue.medida': 'Presentation',
    'catalogue.status': 'Status',
    'catalogue.status.active': 'Active',
    'catalogue.status.notActive': 'Not Active',
    'catalog_item_category.inventory': 'Inventory',
    'catalog_item_category.services': 'Services',
    'catalogue.subcategory': 'Subcategory',
    'catalogue.price_category': 'Price category',

    'subcategories.medicine': 'Medicine',
    'subcategories.service': 'Service',
    'subcategories.supply': 'Supply',
    'subcategories.exam': 'Exam',
    'categories.inventory': 'Inventory',
    'categories.services': 'Services',

    'payment_type.self_pay': 'Self pay',
    'payment_type.social_security': 'Social security',
    'payment_type.insurance': 'Insurance',
    'payment_type.coex': 'COEX',

    'remove_user_popup.remove_confirm_msg': 'Are you sure that you want to remove the {name} account?',
    patient_bills_sssigned_services: 'Assigned Services',
    'error.user_not_found': 'User not found',
    'error.not_valid_credentials': 'Not valid credentials',
    'error.user_not_confirmed': 'User not confirmed',
    'error.user_already_exists': 'User already exists',
    'error.server_unavailable': 'Server unavailable',
    'error.incorrect_symbols': 'Incorrect symbols',
    'error.incorrect_numbers': 'Min - 0, max - 100',
    'error.user-exists': 'User already exists',

    'detailed.company': 'Company',
    'detailed.codigo': 'Code',
    'detailed.descripcion': 'Description',
    'detailed.disponiblecompany': 'Available company',
    'detailed.bodega': 'Store',
    'detailed.nombreBodega': 'Store number',
    'detailed.precio': 'Price',
    'detailed.medida': 'Measure',
    'detailed.expiryDate': 'Expiry date',
    'detailed.paid': 'Paid',
    'detailed.resolved': 'Resolved',
    'detailed.paymentType': 'Payment type',
    'detailed.category': 'Category',
    'detailed.subcategory': 'Subcategory',
    'detailed.documentLink': 'Document link',
    'detailed.doctorJudgement': "Doctor's judgement",
    'forgot_password.user_not_found': 'User not found',
    'user.cases': 'Cases',
    'patient.case': 'Case',
    'view.case': 'View case',
    'case.admission_date': 'Date of receipt',
    'case.discharge_date': 'Discharge date',
    'case.medical_records': 'Medical Records',
    'case.estimate': 'Evaluation',
    'case.total_price': 'Account Price',
    'case.total_payment': 'Total payment',
    'case.total_price_paid': 'Total Price paid',
    'case.total_price_pending': 'Total Price to pay',
    'case.cancel': 'Cancel',
    'case.add': 'Add',
    'case.addNewCase': 'Add new case',
    'case.name': 'Case name',
    'case.budget': 'Case budget',
    'case.totalAccount': 'Account total',
    'case.totalAccountPaid': 'Total Account Paid',
    'case.amountToPay': 'Amount to pay',
    'case.view': 'View case',
    'case.budgetOption.severe': 'Severe',
    'case.budgetOption.mild': 'Mild',
    'case.budgetOption.moderate': 'Moderate',
    'case.noCases': 'There are no available cases, create one.',
  },
  es: {
    'shared.delete': 'Eliminar',
    'shared.add': 'Agregar',
    'shared.cancel': 'Cancelar',
    'shared.close': 'Cerca',
    'shared.quantity': 'Cantidad',
    'shared.name': 'Nombre',
    'shared.date': 'Fecha',
    'shared.code': 'Codigo',
    'shared.description': 'Descripcion',
    'shared.price': 'Precio',
    'shared.subtotal': 'Partial Total',
    'shared.company': 'Compañía',
    'shared.addedBy': 'Agregar por',
    'shared.status': 'Estado',
    'shared.resolvedBy': 'Marcado por',
    'shared.voucherNumber': 'Numero de Vale',

    'auth.signin': 'Ingresa',
    'auth.password': 'Contraseña',
    'auth.forgot_password': '¿Haz olvidado tu contraseña?',
    'auth.dont_have_an_account': '¿Aun no tienes cuenta? Registrate',
    'auth.already_have_an_account': '¿Ya tienes cuenta? Ingresa',
    'auth.reset': 'Reajusta tu Cuenta',
    'auth.sign_up': 'Regístrate',
    'auth.add_admin': 'Crea un Nuevo Usuario',

    calendar: 'Calendario',
    'calendar.from': 'Desde',
    'calendar.to': 'Hasta',
    'calendar.apply': 'Aplicar',
    'calendar.monday': 'Lunes',
    'calendar.tuesday': 'Martes',
    'calendar.wednesday': 'Miercoles',
    'calendar.thursday': 'Jueves',
    'calendar.friday': 'Viernes',
    'calendar.saturday': 'Sabado',
    'calendar.sunday': 'Domingo',
    'calendar.show_picker': 'Muestra Calendario de Disponibilidad',
    'calendar.hide_picker': 'Esconde Calendario de Disponibilidad',
    'calendar.edit': 'Editar',
    'calendar.cancel': 'Cancelar',
    'calendar.delete': 'Eliminar',
    'calendar.add': 'Agregar',
    'calendar.save': 'Salvar',
    'calendar.one_day': 'Un día',
    'calendar.in_range': 'En el rango',
    'doctor.title': 'Título',
    'doctor.title.none': 'N/A',
    'doctor.title.lic': 'Lic.',
    'doctor.title.ing': 'Ing.',
    'doctor.title.ph_d': 'Ph.D.',
    'doctor.title.dr': 'Dr.',
    'doctor.title.mtro': 'Mtro.',
    'doctor.title.mtr': 'Mtr.',
    'doctor.title.sr_sra': 'Sr. / Sra.',
    'doctor.role': 'Posición Laboral',
    'doctor.collegiate_number': 'Numero de Colegiado',
    'doctor.skills': 'Habilidades',
    inventory: 'Inventario',
    'inventory.add_new_item': 'Agrega Inventario',
    'inventory.sku_description': 'Codigo',
    'inventory.inventory_name': 'Nombre',
    'inventory.name': 'Nombre',
    'inventory.date': 'Fecha',
    'inventory.price': 'Precio',
    'inventory.cost': 'Costo',
    'inventory.quantity': 'Cantidad',
    'inventory.total_cost': 'Coste total',
    'inventory.description': 'Nombre',
    'inventory.provide_info': 'Para agregar iventario, favor de llenar este formulario',
    'inventory.add': 'Agregar',
    'inventory.add_service': 'Agrega Servicio',
    'inventory.add_exam': 'Agrega Examen',
    'inventory.add_inventory': 'Agrega Inventario',
    'inventory.cancel': 'Cancelar',
    'inventory.status': 'Estado',
    'inventory.type': 'Tipo',
    'inventory.link': 'Enlazar',
    'inventory.doctor_comment': 'Observaciones médico',
    'inventory.field_to_save_link': 'Campo para guardar enlace',
    'inventory.expert_judge': 'Opinión de expertos',
    'inventory.find_by_sku': 'Buscar por Codigo',
    'inventory.find_by_patient': 'Encuentra por paciente',
    'inventory.details': 'Detalles del inventario',
    'calendar.close': 'Cerrar',

    'navbar.profile': 'Perfil',
    'navbar.medicals': 'Equipo Medico',
    'navbar.patient_record': 'Registros de Pacientes',
    'navbar.calendar': 'Calendario',
    'navbar.services': 'Servicios',
    'navbar.inventory': 'Inventario',
    'navbar.requests': 'Solicitudes',
    'navbar.admin_accounts': 'Cuentas de pacientes',
    'navbar.assigned_services': 'Cuentas de pacientes',
    'patient.bills': 'Cuentas de Patiente',
    'patient.totalAmount': 'Total de cuenta',
    'patient.totalAmountPaid': 'Total de cuenta pagado',
    'patient.totalAmountToPay': 'Total de cuenta pendiente',

    'patient.accountNumber': 'No. Boleta',
    'patient.amount': 'Monto',
    'patient.registered': 'Registrado Por',
    'patient.addNewPayment': 'Agregar Saldo a Cuenta',
    'patient.checkout': 'Revisa',

    position: 'Tipo de Cuenta',
    'position.none': 'N/A',
    'position.doctor': 'Medico',
    'position.pharmacist': 'Farmaceuta',
    'position.nurse': 'Enfermera',
    'position.patient': 'Paciente',
    'position.technician_radiology': 'Tecnico de Radiologia',
    'position.technician_labs': 'Tecnico de Laboratorio',
    'position.technition': 'Tecnico',
    'position.admin': 'Webmaster',
    'position.staff': 'Encargado',
    'position.find_specialist': 'Encuentra miembro del staff',
    'position.find_patient': 'Encuentra a paciente',
    'position.find_request': 'Buscar solicitud',
    'position.find_service': 'Encuentra servicio',
    'position.find_inventory': 'Encuentra inventario',
    'position.find_catalog': 'Buscar catalogo',
    profile: 'Perfil',
    'profile.edit_profile': 'Editar Perfil',
    'profile.view_profile': 'Ver Perfil',
    'record.name': 'Nombre',
    'record.author': 'Autor',
    'record.date': 'Fecha',
    'record.add_new': 'Agregar nuevo record medico',
    'request.add_new_item': 'Agregar nuevo examen',
    request: 'Solicitud',
    services: 'Servicios',
    'services.exams': 'Exámenes',
    'services.add_new_item': 'Agregar Nuevo Servicio',
    'services.sku_description': 'Codigo',
    'services.sku': 'Codigo',
    'services.name': 'Nombre',
    'services.price': 'Precio',
    'services.title': 'Nombre',
    'services.description': 'Descripcion',
    'services.medida': 'Presentación',
    'services.status': 'Estado',
    'services.provide_info': 'Para agregar un nuevo servicio, favor de llenar este formulario',
    'services.add': 'Agregar',
    'services.cancel': 'Cancelar',
    'services.service.name': 'Nombre del Servicio',
    'services.type': 'Tipo',
    'services.doctor_comment': 'Comentario del doctor',
    'services.deadline_date': 'Fecha límite',
    'services.company': 'Compañía',
    exams: 'Exámenes',
    'exam.sku_description': 'Codigo',
    'exam.sku': 'Codigo',
    'exam.name': 'Nombre',
    'exam.price': 'Precio',
    'exam.description': 'Descripcion',
    'exam.status': 'Estado',
    'exam.add_new_exam': 'Agregar Nuevo Examine',
    medicaments: 'Medicamentos',
    'medicament.sku_description': 'Codigo',
    'medicament.sku': 'Codigo',
    'medicament.name': 'Nombre',
    'medicament.price': 'Precio',
    'medicament.quantity': 'Cantidad',
    'medicament.total_cost': 'Coste total',
    'medicament.status': 'Estado',
    'medicament.add_new_item': 'Agregar Nuevo Medicamento',
    supplies: 'Suministros',
    'supply.sku_description': 'Codigo',
    'supply.sku': 'Codigo',
    'supply.name': 'Nombre',
    'supply.price': 'Precio',
    'supply.quantity': 'Cantidad',
    'supply.total_cost': 'Coste total',
    'supply.status': 'Estado',
    'supply.add_new_item': 'Agregar Nuevo Suministros',
    'user.email_adress': 'Correo Electrónico',
    'user.phone': 'Telefono',
    'user.first_name': 'Nombre',
    'user.name': 'Nombre',
    'user.last_name': 'Apellido',
    'user.role': 'El rol',
    'user.search': 'Buscar',
    'user.payment_type': 'Forma de Pago',
    'user.view': 'Ver',
    'user.profile': 'Perfil',
    'user.assign_doctor': 'Asignarle Medico',
    'user.remove': 'Eliminar',
    'user.accounts': 'Cuentas',
    'user.medical_records': 'Registros Médicos',
    'user.medical_record': 'Historial médico',
    'user.add_comment': 'Agregar Nota',
    'user.observation': 'Notas',
    'user.leave_comment': 'Deja un comentario',
    'users.confirm_removing': 'Confirmar la eliminación',
    'user.not_found': 'Usuario no encontrado',
    'VAT.percent': 'VAT',
    'vat.change_value': 'Cambiar VAT',
    'home.log_in': 'Ingresa',
    'auth.back_to_login': 'Atrás',
    'auth.restore_link_sent': 'El enlace se envió a su correo electrónico permitiendo configurar su contraseña',
    'service.status.paid': 'Pagado',
    'service.status.unpaid': 'No pagado',
    'service.payment_status': 'Estado de pago',
    'calendar.Lunes': 'Lunes',
    'calendar.Martes': 'Martes',
    'calendar.Miercoles': 'Miercoles',
    'calendar.Jueves': 'Jueves',
    'calendar.Viernes': 'Viernes',
    'calendar.Sabado': 'Sabado',
    'calendar.Domingo': 'Domingo',
    'calendar.new_event': 'Agregar nuevo evento',
    'calendar.provide_event_info': 'Para agregar su evento al calendario, proporcione información en la entrada a continuación.',
    'calendar.provide_event_label': 'Información del Evento',
    'medical_record.man': 'Hombre',
    'medical_record.woman': 'Mujer',
    'medical_records.medical_records': 'Record Medico',
    'medical_records.dialog_title': 'Agregar record medico nuevo',
    'medical_records.record_name': 'Descripción de Record Medico',
    'medicalRecord.author': 'Autor',
    'medicalRecord.viewMedRecord': 'Ver récord médico',
    'medicalRecord.addNewRecord': 'Agregar nuevo record medico',

    'patient.download_info': 'Download patient info',
    'patient_dialog.assign_doctor': 'Asignar Medico',
    'patient_dialog.doctor': 'Medico',
    'patient_dialog.assign': 'Asignar',
    'patient.self_pay': 'Pago por Cuenta Propia',
    'patient.social_security': 'Seguridad Social',

    'exam.mark_as_done': 'Hecho',
    'exam.close_request': 'Cerrar solicitud',
    'exam.document_link': 'Enlace de documento',
    'exam.expert_judgement': 'Opinión de expertos',

    'service_item_type.service': 'Servicio',
    'service_item_type.surgery': 'Cirugía',
    'service_item_type.laboratory_exam': 'Examen de laboratorio',
    'service_item_type.radiological_exam': 'Examen de Radiologia',
    'service_item_type.procedure': 'Procedimiento',
    'service_item_type.hospitality': 'Hospitalidad',

    'accounts_table.exam_dialog_info': 'Información del examen',
    'accounts_table.exam_dialog_close': 'Cerca',
    'accounts_table.medicament_dialog_info': 'Información de medicamentos',
    'accounts_table.medicament_dialog_close': 'Cerca',
    'accounts_table.supply_dialog_info': 'Información de suministro',
    'accounts_table.supply_dialog_close': 'Cerca',

    'assign_inventory.title': 'Seleccionar inventario',
    'assign_inventory.info': 'Seleccionar inventario',
    'assign_inventory.quantity': 'Cantidad',
    'assign_inventory.paymentType': 'Método de pago',
    'assign_inventory.cash': 'Efectivo',
    'assign_inventory.insurance': 'Seguro',
    'assign_inventory.credit_card': 'Tarjeta de crédito',
    'assign_request.title': 'Seleccionar examen',
    'assign_request.exam': 'Examen',
    'assign_request.quantity': 'Método de pago',
    'assign_request.paymentType': 'Método de pago',
    'assign_request.deadline': 'Fecha',
    'assign_request.comment': 'Comentario',
    'assign_service.title': 'Seleccionar servicio',
    'assign_service.service': 'Servicio',
    'assign_service.paymentType': 'Método de pago',

    'navbar.logout': 'Cerrar sesión',
    'patient.case_ID': 'ID del Caso',

    'medical_record.restore_fields': 'Restaurar campos',
    'medical_record.field': 'Campo',

    'medical_record.laboratory_exams': 'Examenes de Laboratorio',
    'medical_record.radiological_exams': 'Examenes de Radiologia',
    'medical_record.clinical_treatment': 'Tratamiento Clinico',
    'medical_record.surgical_treatment': 'Tratamiento Quirúrgico',
    'medical_record.procedures_in_treatment': 'Procedimientos en Tratamiento',

    'medical_record.vital_signs': 'Signos vitales',
    'medical_record.personal_medical_history': 'Historia Medica Personal',
    'medical_record.family_medical_history': 'Historia Medica Familiar',
    'medical_record.symptoms': 'Sintomas',
    'medical_record.signs': 'Signos',
    'medical_record.gender': 'Genero',
    'medical_record.age': 'Edad',
    'medical_record.address': 'Direccion de Domicilio',
    'medical_record.recent_trips': 'Viajes Recientes',
    'medical_record.weight': 'Peso',
    'medical_record.height': 'Altura',
    'medical_record.body_temperature': 'Temperatura Corporal',
    'medical_record.heart_rate': 'Frecuencia Cardiaca',
    'medical_record.bpm': 'Respiraciones por Minuto',
    'medical_record.blood_pressure': 'Presion Sanguinea',
    'medical_record.oxygen_saturation': 'Saturacion de Oxigeno',
    'medical_record.sodium_blood_test': 'Examen de Sodio en la Sangre',
    'medical_record.potassium_blood_test': 'Examen de Potasio en la Sangre',
    'medical_record.chloride_blood_test': 'Examen de Cloruro en la Sangre',
    'medical_record.bicarbonate_blood_test': 'Examen de CO2 en la Sangre',
    'medical_record.blood_urea_nitrogen_test': 'Examen de Nitrogeno de Urea en la Sangre',
    'medical_record.glucose_blood_test': 'Examen de Glucosa en la Sangre',
    'medical_record.platelet_blood_count': 'Conteo de Plaquetas en la Sangre',
    'medical_record.creatinine_blood_test': 'Examen de Creatinina en la Sangre',
    'medical_record.white_blood_cell_count': 'Conteo de Glóbulos Blancos',
    'medical_record.hematocrit_blood_test': 'Analisis de Hematocrito',
    'medical_record.liver_function_tests': 'Examenes de Funcionalidad Hepatica',
    'medical_record.kidney_function_tests': 'Examenes de Funcionalidad Renal',
    'medical_record.special_request_tests': 'Examenes Especiales',
    'medical_record.ultrasound_results': 'Resultados de Ultrasonido',
    'medical_record.x_rays_results': 'Resultados de Rayos-X',
    'medical_record.ct_scan_results': 'Resultados de Tomografia',
    'medical_record.mri_results': 'Resultados de Resonancia Magnetica',
    'medical_record.pet/ct_results': 'Resultados de PET/CT',
    'medical_record.diagnostic': 'Diagnostico',
    'medical_record.days_in_treatment': 'Dias de Tratamiento',
    'medical_record.medication_for_treatment': 'Medicamentos para Tratamiento',

    'inventory_type.medicine': 'Medicina',
    'inventory_type.supplies': 'Suministros',
    'inventory_type.supply': 'Suministro',
    'inventory_type.service': 'Servicio',
    'inventory_type.services': 'Servicios',
    'inventory_type.exam': 'Examen',
    'inventory_type.inventory': 'Inventario',
    'patient_modal.add_new_patient': 'Añadir nuevo paciente',
    'doctor_modal.add_new_medical': 'Asigna a nuevo medico',
    'doctor_modal.add_new_admin': 'Asigna a nuevo webmaster',
    catalogue: 'catálogo',
    'catalogue.sku': 'Codigo',
    'catalog.inventory': 'Catálogo',
    'catalogue.name': 'Nombre del catálogo',
    'catalogue.add_new_item': 'Agregar nuevo catálogo',
    'catalogue.medicamentos': 'Medicamentos',
    'catalogue.price': 'Precio',
    'catalogue.type': 'Tipo',
    'catalogue.category': 'Categoría',
    'catalogue.cancel': 'Cancelar',
    'catalogue.add': 'Agregar',
    'catalogue.provide_info': 'Para agregar su artículo de catálogo, favor de llenar este formulario',
    'catalogue.compania': 'Compañía',
    'catalogue.codigo': 'Codigo',
    'catalogue.descripcion': 'Descripción',
    'catalogue.disponible': 'Cantidad',
    'catalogue.bodega': 'Bodega',
    'catalogue.nombreBodega': 'Compañía',
    'catalogue.precio': 'Precio',
    'catalogue.medida': 'Presentacion',
    'catalogue.status': 'Estado',
    'catalogue.status.active': 'Activo',
    'catalogue.status.notActive': 'No activo',
    'catalog_item_category.inventory': 'Inventario',
    'catalog_item_category.services': 'Servicios',
    'catalogue.subcategory': 'Subcategoría',
    'subcategories.medicine': 'Medicina',
    'subcategories.service': 'Servicio',
    'subcategories.supply': 'Suministro',
    'subcategories.exam': 'Examen',
    'categories.inventory': 'Inventario',
    'categories.services': 'Servicios',
    'catalogue.price_category': 'Categoría de precio',
    'payment_type.self_pay': 'Pago por Cuenta Propia',
    'payment_type.social_security': 'Seguridad Social',
    'payment_type.insurance': 'Seguros',
    'payment_type.coex': 'COEX',

    'remove_user_popup.remove_confirm_msg': '¿Estás seguro de que quieres eliminar la cuenta de {name}?',
    patient_bills_sssigned_services: 'Servicios Asignados',

    'error.user_not_found': 'Usuario no encontrado',
    'error.not_valid_credentials': 'Credenciales no validas',
    'error.user_not_confirmed': 'Usuario no confirmado',
    'error.user_already_exists': 'El usuario ya existe',
    'error.server_unavailable': 'Servidor no disponible',
    'error.incorrect_symbols': 'Símbolos incorrectos',
    'error.incorrect_numbers': 'Mínimo - 0, máximo - 100',
    'error.user-exists': 'El usuario ya existe',

    'detailed.company': 'Compañía',
    'detailed.codigo': 'Codigo',
    'detailed.descripcion': 'Descripcion',
    'detailed.disponiblecompany': 'Disponible compañía',
    'detailed.bodega': 'Bodega',
    'detailed.nombreBodega': 'Nombre bodega',
    'detailed.precio': 'Precio',
    'detailed.medida': 'Medida',
    'detailed.expiryDate': 'Fecha de caducidad',
    'detailed.paid': 'Pagado',
    'detailed.resolved': 'Resuelto',
    'detailed.paymentType': 'Tipo de pago',
    'detailed.category': 'Categoría',
    'detailed.subcategory': 'Subcategoría',
    'detailed.documentLink': 'Enlace de documento',
    'detailed.doctorJudgement': 'Juicio del doctor',
    'forgot_password.user_not_found': 'Usuario no encontrado',
    'user.cases': 'Casos',
    'patient.case': 'Caso',
    'view.case': 'Ver caso',
    'case.admission_date': 'Fecha de Ingreso',
    'case.discharge_date': 'Fecha de Engreso',
    'case.estimate': 'Presupuesto',
    'case.total_price': 'Total de la Cuenta',
    'case.total_payment': 'Pago total',
    'case.total_price_paid': 'Total de Cuenta Pagado',
    'case.total_price_pending': 'Total de Cuenta Pendiente',
    'case.medical_records': 'Registros Médicos',
    'case.cancel': 'Cancelar',
    'case.add': 'Añadir',
    'case.addNewCase': 'Agregar nuevo caso',
    'case.name': 'Nombre del caso',
    'case.budget': 'Presupuesto del caso',
    'case.totalAccount': 'Total de la Cuenta',
    'case.totalAccountPaid': 'Total de la Cuenta Pagado',
    'case.amountToPay': 'Total de la Cuenta Pendiente',
    'case.view': 'View case',
    'case.budgetOption.severe': 'Severo',
    'case.budgetOption.mild': 'Leve',
    'case.budgetOption.moderate': 'Moderado',
    'case.noCases': 'No hay casos disponibles, cree uno.',
  },
};
